export default "/images/c8f8ff175fe52cb051d4e2a946fceb18.png";